<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Profile Bar"
    seFeDataSubtitle="A profile bar component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component as the top bar with the user's avatar</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="ProfileBarComponent"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="profileBarComponent">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-profile-bar-example></se-po-profile-bar-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
